module.exports = __webpack_public_path__ + "static/img/ent-57.95a6f6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-57.jpg
// module id = 6c/Z
// module chunks = 51